import { createContext, PropsWithChildren, useContext } from "react";
type TemplateData = {
  type: string;
  key?: string;
}

const TemplateDataContext = createContext<TemplateData | undefined>(undefined);

export function TemplateDataProvider({ children, templateData }: PropsWithChildren<{}> & {templateData: TemplateData}) {
  return <TemplateDataContext.Provider value={templateData}>{children}</TemplateDataContext.Provider>;
}

export function useTemplateData() {
  const templateData = useContext(TemplateDataContext);
  if (templateData === undefined) {
    throw new Error("useTemplateData must be used within a TemplateDataContext");
  }
  return templateData;
}
